import { render, staticRenderFns } from "./SecondGraduationInstitutionInfoForm.vue?vue&type=template&id=b4ab5c2a&scoped=true&"
import script from "./SecondGraduationInstitutionInfoForm.vue?vue&type=script&lang=ts&"
export * from "./SecondGraduationInstitutionInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./SecondGraduationInstitutionInfoForm.vue?vue&type=style&index=0&id=b4ab5c2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ab5c2a",
  null
  
)

export default component.exports